import { persistor } from "../store";

export const logout = async (auth) => {
  auth.signoutRedirect({ id_token_hint: auth.user?.id_token });
  await auth.removeUser();
  localStorage.clear();
  persistor.purge();
};
